import { FC } from 'react';
import statusIndicatorCompleted from '../../../images/statusIndicatorCompleted.svg';
import statusIndicatorActive from '../../../images/statusIndicatorActive.svg';

type TimelineStatusIconProps = {
    isCompleted: boolean;
    isActive: boolean;
};

const TimelineStatusIcon: FC<TimelineStatusIconProps> = ({ isCompleted, isActive }) => {
    if (isCompleted) {
        return <img src={statusIndicatorCompleted} alt='Resolved' className='w-30 h-30 flex-shrink-0' />;
    }

    if (isActive) {
        return <img src={statusIndicatorActive} alt='In Progress' className='w-30 h-30 flex-shrink-0' />;
    }

    return <img src={statusIndicatorCompleted} alt='Resolved' className='w-30 h-30 flex-shrink-0' />;
};

export default TimelineStatusIcon;
